<!--
Not in use since we have a more interactive and controllable splash screen.

If you want to get this back then just add
loading="LoadingLayout"
to vue-extend-layouts in App.vue.
-->

<template>
  <div class="layout">
    <div id="loader">
      <div class="loading-info">
        <img src="~@/assets/img/logo-with-bees.svg">
        <div class="load-text">Preparing AI Number...</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingLayout',
};
</script>
<style scoped>
  #loader {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background: #f8f9fa;
    margin: 0 auto;
    text-align: center;
    z-index: 10000;
  }

  #loader .loading-info {
    position: relative;
    margin: calc(50vh - 105px) auto 0;
    width: 290px;
    height: 174px;
    font-size: 16px;
    font-weight: 700;
    color: #b1b8c4;
  }

  .loading-info .load-text {
    width: 290px;
  }

  .loading-info img {
    width: 290px;
    height: 135px;
    margin-bottom: 20px;
  }
</style>
